import Vue from 'vue';
import NewsPage from './pages/news.vue';

jQuery(function($) {
  initApp($);
});

function initApp ($) {
  window.$ = $;
  window._ = _;

  if ($('.news-page-wrapper').length) {
    window.news = new (Vue.extend(NewsPage))({
      el: '.news-wrapper'
    });
  }
}
